import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

interface Tab {
  id: string;
  label: string;
}

interface GlassTabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}

export const GlassTabs = ({ tabs, activeTab, onChange, className }: GlassTabsProps) => {
  return (
    <div className={cn("flex space-x-1 rounded-xl bg-white/5 p-1 border border-white/10", className)}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={cn(
            "relative flex-1 rounded-lg px-3 py-2 text-sm font-medium transition-colors focus-visible:outline-none",
            activeTab === tab.id ? "text-white" : "text-muted-foreground hover:text-white"
          )}
        >
          {activeTab === tab.id && (
            <motion.div
              layoutId="activeTab"
              className="absolute inset-0 bg-primary/20 border border-primary/30 rounded-lg shadow-neon"
              initial={false}
              transition={{ type: "spring", stiffness: 500, damping: 30 }}
            />
          )}
          <span className="relative z-10">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};
